import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelText as _vModelText, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-36cebe6f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-dialog modal-lg" }
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "modal-body px-lg-3 px-2" }
const _hoisted_4 = { class: "mb-4 mb-lg-5 fs-75" }
const _hoisted_5 = { class: "d-flex mx-0 px-0 mb-4" }
const _hoisted_6 = {
  key: 0,
  class: "d-flex mx-0 px-0 mb-4 fs-75"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "※", -1))
const _hoisted_8 = { class: "mx-0 px-0" }
const _hoisted_9 = { class: "row mx-0 px-0 gx-3 mb-0 border-bottom" }
const _hoisted_10 = { class: "w-max-content col-md-3 col-form-label fs-7" }
const _hoisted_11 = { class: "w-max-content col-md-1 col-form-label" }
const _hoisted_12 = { class: "col-md-8 col-form-label" }
const _hoisted_13 = ["for"]
const _hoisted_14 = ["id", "value"]
const _hoisted_15 = {
  key: 0,
  class: "invalid-feedback custom-message fs-7"
}
const _hoisted_16 = { class: "row mx-0 px-0 pb-3 gx-3 mb-0 pt-4 border-bottom" }
const _hoisted_17 = { class: "w-max-content col-md-3 col-form-label fs-7" }
const _hoisted_18 = { class: "w-max-content col-md-1 col-form-label" }
const _hoisted_19 = { class: "col-md-8" }
const _hoisted_20 = { class: "form-check mb-2 mb-lg-3 ps-0 fs-7" }
const _hoisted_21 = {
  key: 0,
  class: "invalid-error"
}
const _hoisted_22 = {
  key: 1,
  class: "invalid-error mar-bot-15"
}
const _hoisted_23 = {
  key: 2,
  class: "invalid-error mar-bot-15"
}
const _hoisted_24 = {
  key: 3,
  class: "invalid-error mar-bot-15"
}
const _hoisted_25 = { class: "row mx-0 px-0 pb-4 gx-3 mb-0" }
const _hoisted_26 = { class: "w-max-content col-md-4 col-form-labe fs-7" }
const _hoisted_27 = { class: "col-md-8" }
const _hoisted_28 = { class: "form-check mb-2 mb-lg-3 ps-0" }
const _hoisted_29 = { class: "input-group mb-3 d-flex fs-7" }
const _hoisted_30 = {
  class: "input-group cursor-pointer",
  for: "filesFirst"
}
const _hoisted_31 = {
  for: "filesFirst",
  class: "input-group-text cursor-pointer fs-7"
}
const _hoisted_32 = { class: "form-control text-break fs-7" }
const _hoisted_33 = {
  key: 0,
  class: "invalid-error"
}
const _hoisted_34 = { class: "row" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-4" }, null, -1))
const _hoisted_36 = { class: "col-md-8" }
const _hoisted_37 = { class: "fs-7" }
const _hoisted_38 = { class: "fs-7" }
const _hoisted_39 = { class: "fs-7" }
const _hoisted_40 = { class: "row mx-0 px-0 pb-4 gx-3 mb-0 fs-7" }
const _hoisted_41 = { class: "w-max-content col-md-4 col-form-label" }
const _hoisted_42 = { class: "col-md-8" }
const _hoisted_43 = { class: "form-check mb-2 mb-lg-3 ps-0" }
const _hoisted_44 = { class: "input-group mb-3" }
const _hoisted_45 = {
  class: "input-group cursor-pointer",
  for: "filesSecond"
}
const _hoisted_46 = {
  for: "filesSecond",
  class: "input-group-text cursor-pointer fs-7"
}
const _hoisted_47 = { class: "form-control text-break fs-7" }
const _hoisted_48 = {
  key: 0,
  class: "invalid-error"
}
const _hoisted_49 = { class: "row" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-4" }, null, -1))
const _hoisted_51 = { class: "col-md-8" }
const _hoisted_52 = { class: "fs-7" }
const _hoisted_53 = { class: "fs-7" }
const _hoisted_54 = { class: "fs-7" }
const _hoisted_55 = { class: "row mx-0 px-0 pb-4 gx-3 mb-0 fs-7" }
const _hoisted_56 = { class: "w-max-content col-md-4 col-form-label" }
const _hoisted_57 = { class: "col-md-8" }
const _hoisted_58 = { class: "form-check mb-2 mb-lg-3 ps-0" }
const _hoisted_59 = { class: "input-group mb-3" }
const _hoisted_60 = {
  class: "input-group cursor-pointer",
  for: "filesThird"
}
const _hoisted_61 = {
  for: "filesThird",
  class: "input-group-text cursor-pointer"
}
const _hoisted_62 = { class: "form-control text-break" }
const _hoisted_63 = {
  key: 0,
  class: "invalid-error"
}
const _hoisted_64 = { class: "row" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-4" }, null, -1))
const _hoisted_66 = { class: "col-md-8" }
const _hoisted_67 = { class: "fs-7" }
const _hoisted_68 = { class: "fs-7" }
const _hoisted_69 = { class: "fs-7" }
const _hoisted_70 = { class: "row mx-0 px-0 pb-4 gx-3 mb-0 border-bottom border-top pt-4" }
const _hoisted_71 = { class: "w-max-content col-md-3 col-form-label fs-7" }
const _hoisted_72 = { class: "w-max-content col-md-1 col-form-label" }
const _hoisted_73 = { class: "col-md-8" }
const _hoisted_74 = { class: "form-check mb-2 mb-lg-3 ps-0" }
const _hoisted_75 = { class: "col-lg-12" }
const _hoisted_76 = { class: "form-check mb-2 mb-lg-3 ps-0" }
const _hoisted_77 = { class: "row mx-0 px-0 d-flex justify-content-center flex-lg-row flex-column-reverse mt-3" }
const _hoisted_78 = { class: "col-lg-6 d-flex justify-content-lg-end justify-content-center" }
const _hoisted_79 = { class: "col-lg-6 d-flex justify-content-lg-start justify-content-center mb-4 mb-lg-0" }

import { computed, ComputedRef, ref, watch, watchEffect, onMounted } from 'vue'
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'
import { email, maxLength, minLength } from '@vuelidate/validators'
import useVuelidate from '@vuelidate/core'

import Status from '@/components/status/index.vue'
import Button from '@/components/button/index.vue'
import InputErrorMessage from '@/components/input-error-message/InputErrorMessage.vue'
import InquiryConfirmModal from '../inquiry-confirmation/index.vue'
import ErrorMessage from '@/components/error-message/index.vue'

import { translate } from '@/languages/i18n'
import { COMMUNITY_STORE, INQUIRY_STORE, ROOT_STORE } from '@/store/constants'
import { REGEX_EMOJI } from '@/constants/regex'
import { DEFAULT_MAX_LENGTH, DEFAULT_MAX_LENGTH_TEXTAREA, MIN_LENGTH_EMAIL, MAX_LENGTH_EMAIL } from '@/constants/number'
import { debounce } from 'lodash'
import commonService from '@/services/common.service'
import { useAuthenticated } from '@/use/authentication'
import { CommunityStateTypes } from '@/store/modules/community'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { authenticated } = useAuthenticated()

const router = useRouter()
const route = useRoute()
const store = useStore()

const inquiryData = computed(() => store.getters[INQUIRY_STORE.GETTERS.INQUIRY_DATA])
const inquiryCategories = computed(() => store.getters[INQUIRY_STORE.GETTERS.INQUIRY_CATEGORIES])
const isMobile = computed(() => store.getters[ROOT_STORE.GETTERS.CHECK_MOBILE_DEVICE])
const getMe = computed<ComputedRef<Pick<CommunityStateTypes, 'me'>>>(() => store.getters[COMMUNITY_STORE.GETTERS.GET_ME])

const myFilesFirst = ref(null)
const fileNameFirst = ref<string>('')
const myFilesSecond = ref(null)
const fileNameSecond = ref<string>('')
const myFilesThird = ref(null)
const fileNameThird = ref<string>('')

const checkBoxes = ref<any[]>([])
const serverError = ref<boolean>(false)
watch(
  () => authenticated.value,
  () => {
    authenticated.value && route.path !== `/${route.path.split('/')[1]}/reset_mail_finished` && store.dispatch(INQUIRY_STORE.ACTIONS.SET_INQUIRY_CATEGORIES)
  },
  {
    immediate: true,
  }
)
onMounted(() => {
  window.addEventListener('hidden.bs.modal', function () {
    v$.value.$reset()
  })
})

watchEffect(() => {
  checkBoxes.value = Object.entries(inquiryCategories.value).map((item: any) => {
    return { id: item[0], title: item[1] }
  })
})

const fileFirst = ref(false)
const handleChangeFileFirst = (): void => {
  fileNameFirst.value = myFilesFirst.value?.files[0]?.name
  inquiryData.value.file1 = myFilesFirst.value?.files[0]
  let typeFile = myFilesFirst.value?.files[0]?.type
  if (['text/plain', 'application/pdf', 'image/jpeg', 'image/jpg', 'image/png'].includes(typeFile) || typeFile === null) {
    fileFirst.value = false
  } else {
    fileFirst.value = true
  }
}

const handleDeleteFile1 = (): void => {
  fileNameFirst.value = ''
  inquiryData.value.file1 = ''
  fileFirst.value = false
}

const fileSecond = ref(false)
const handleChangeFileSecond = (): void => {
  fileNameSecond.value = myFilesSecond.value?.files[0]?.name
  inquiryData.value.file2 = myFilesSecond.value?.files[0]
  let typeFile = myFilesSecond.value?.files[0]?.type
  if (['text/plain', 'application/pdf', 'image/jpeg', 'image/jpg', 'image/png'].includes(typeFile) || typeFile === null) {
    fileSecond.value = false
  } else {
    fileSecond.value = true
  }
}

const handleDeleteFile2 = (): void => {
  fileNameSecond.value = ''
  inquiryData.value.file2 = ''
  fileSecond.value = false
}

const fileThird = ref(false)
const handleChangeFileThird = (): void => {
  fileNameThird.value = myFilesThird.value?.files[0]?.name
  inquiryData.value.file3 = myFilesThird.value?.files[0]
  let typeFile = myFilesThird.value?.files[0]?.type
  if (['text/plain', 'application/pdf', 'image/jpeg', 'image/jpg', 'image/png'].includes(typeFile) || typeFile === null) {
    fileThird.value = false
  } else {
    fileThird.value = true
  }
}
const handleDeleteFile3 = (): void => {
  fileNameThird.value = ''
  inquiryData.value.file3 = ''
  fileThird.value = false
}

const handleFile = (event) => {
  event.target.value = ''
}

const rules = computed(() => {
  return {
    content: {
      requiredInquiryContent: function (value) {
        return !!value
      },
      maxLength: maxLength(DEFAULT_MAX_LENGTH_TEXTAREA),
      pictograms: function (value) {
        if (!value) {
          return true
        }
        return REGEX_EMOJI.test(value)
      },
    },
    // file1: {
    //   checkTypeImage: function (value) {
    //     console.log(value.type)
    //     return ['image/png', 'image/jpeg', 'image/jpg', 'application/pdf', 'text/plain'].includes(value?.type)
    //   },
    // },
    email: {
      requiredEmailReply: function (value) {
        return !!value
      },
      maxLength: maxLength(MAX_LENGTH_EMAIL),
      minLength: minLength(MIN_LENGTH_EMAIL),
      email,
      pictograms: function (value) {
        if (!value) {
          return true
        }
        return REGEX_EMOJI.test(value)
      },
    },
  }
})

const formData = ref(inquiryData)
const v$ = useVuelidate(rules, formData)

const onSubmit = () => {
  v$.value.$touch()
  if (formData.value?.content.replace(/(\r\n|\n|\r)/g, '  ').length > 2000) {
    v$.value.$invalid = true
  }
  if (fileFirst.value || fileSecond.value || fileThird.value || v$.value.$invalid) {
    return
  }

  store.dispatch(INQUIRY_STORE.ACTIONS.SET_INQUIRY_DATA, formData.value)
}

const handleBackFAQ = (): void => {
  v$.value.$reset()
  store.dispatch(INQUIRY_STORE.ACTIONS.SET_INQUIRY_DATA, {
    inquiry_type: '1',
    content: '',
    file1: '',
    file2: '',
    file3: '',
    email: '',
  })
  handleDeleteFile1()
  handleDeleteFile2()
  handleDeleteFile3()
}

const handleTransitDirect = () => {
  router.push(`/${route.path.split('/')[1]}/communities/${route.params.id}/direct_chat/${getMe.value?.direct_id}`)
}

const handleServerError = (status: boolean): void => {
  serverError.value = status
}

const ngKeyContent = ref<boolean>(false)
const checkNGContent = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.content.$model })
  ngKeyContent.value = data.data?.data?.has_ngword
}, 200)

watch(
  () => formData.value?.content,
  () => {
    if (v$.value.content.$model.replace(/(\r\n|\n|\r)/g, '  ').length > 2000) {
      v$.value.$invalid = true
    }
  }
)

watchEffect(() => {
  if (!inquiryData.value.email) serverError.value = false
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "modal fade",
      id: "inquiryFormModal",
      tabindex: "-1",
      "aria-labelledby": "inquiryFormModal",
      "aria-hidden": "true",
      ref: (_value, _refs) => {
        _refs['modalTest'] = _value
      }
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close",
              onClick: handleBackFAQ
            })
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("form", {
              onSubmit: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"])),
              class: "bg-white p-0 p-lg-4 pt-0 pt-lg-0",
              novalidate: ""
            }, [
              _createElementVNode("h1", {
                class: _normalizeClass(['fw-bold text-center mb-4 mb-lg-5', _unref(isMobile) ? 'fs-6' : 'fs-5'])
              }, _toDisplayString(_unref(translate)('inquiry')), 3),
              (serverError.value)
                ? (_openBlock(), _createBlock(ErrorMessage, {
                    key: 0,
                    title: _unref(translate)('inquiryServerFailed')
                  }, null, 8, ["title"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", null, _toDisplayString(_unref(translate)('ST50noteInquiry')), 1)
                ]),
                (_unref(route).params.id)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _hoisted_7,
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("span", null, _toDisplayString(_unref(translate)('ST50forInquiryAboutCommunity')), 1),
                        _createElementVNode("span", {
                          class: "link text-decoration-underline cursor-pointer",
                          "data-bs-dismiss": "modal",
                          onClick: handleTransitDirect
                        }, _toDisplayString(_unref(translate)('ST50here')), 1),
                        _createElementVNode("span", null, _toDisplayString(_unref(translate)('ST50thanks')), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("label", _hoisted_10, _toDisplayString(_unref(translate)('inquiryType')), 1),
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(Status)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(checkBoxes.value, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "form-check mb-2 mb-lg-3",
                      key: item.id
                    }, [
                      _createElementVNode("label", {
                        class: "form-check-label fs-7",
                        for: item.id
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.inquiry_type) = $event)),
                          type: "radio",
                          name: "checkboxDefault",
                          id: item.id,
                          value: item.id
                        }, null, 8, _hoisted_14), [
                          [_vModelRadio, formData.value.inquiry_type]
                        ]),
                        _createTextVNode(" " + _toDisplayString(item.title), 1)
                      ], 8, _hoisted_13)
                    ]))
                  }), 128)),
                  (!formData.value.inquiry_type)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_unref(translate)('requiredInput', 'inquiryType')), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("label", _hoisted_17, _toDisplayString(_unref(translate)('inquiryContent')), 1),
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(Status)
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _withDirectives(_createElementVNode("textarea", {
                      rows: "4",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(v$).content.$model) = $event)),
                      class: _normalizeClass(['form-control fs-7', formData.value?.content?.replace(/(\r\n|\n|\r)/g, '  ').length > 2000 || ngKeyContent.value || _unref(v$).content.$error ? 'is-invalid' : '']),
                      placeholder: "入力してください。",
                      onKeyup: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(checkNGContent) && _unref(checkNGContent)(...args))),
                      onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(checkNGContent) && _unref(checkNGContent)(...args)))
                    }, null, 34), [
                      [
                        _vModelText,
                        _unref(v$).content.$model,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    (ngKeyContent.value && !_unref(v$).content.$error)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                      : (formData.value?.content?.replace(/(\r\n|\n|\r)/g, '  ').length > 2000)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(_unref(translate)('minMaxString', _unref(translate)(`inquiryContent`), [1, 2000])), 1))
                        : (_unref(v$).content.$error && formData.value?.content?.replace(/(\r\n|\n|\r)/g, '  ').length < 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(_unref(translate)('requiredInput', _unref(translate)(`inquiryContent`), [1, 2000])), 1))
                          : (_unref(v$).content.$error && _unref(v$).content.$errors[0]?.$validator === 'pictograms')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(_unref(translate)('validatePictograms')), 1))
                            : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("h3", {
                class: _normalizeClass(['fw-bold pt-4', _unref(isMobile) ? 'fs-75' : 'fs-7'])
              }, " エラーが表示される場合にはスクリーンショットをご提供ください。その他の情報もご添付いただけます。 ", 2),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("label", _hoisted_26, _toDisplayString(_unref(translate)('attachment')) + "(1)", 1),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("input", {
                        type: "file",
                        ref: (_value, _refs) => {
                          _refs['myFilesFirst'] = _value
                          myFilesFirst.value = _value
                        },
                        id: "filesFirst",
                        accept: "image/png, image/jpeg, image/jpg, application/pdf, text/plain",
                        onChange: handleChangeFileFirst,
                        onClick: handleFile,
                        class: "form-control d-none",
                        placeholder: "ファイル選択"
                      }, null, 544),
                      _createElementVNode("label", _hoisted_30, [
                        _createElementVNode("label", _hoisted_31, _toDisplayString(_unref(translate)('selectFile')), 1),
                        _createElementVNode("span", _hoisted_32, _toDisplayString(_unref(inquiryData)?.file1 ? fileNameFirst.value : '選択されていません'), 1),
                        _createElementVNode("label", {
                          onClick: handleDeleteFile1,
                          class: "input-group-text cursor-pointer bg-whitefs-6"
                        }, _toDisplayString(_unref(translate)('ST50cancelFile')), 1)
                      ]),
                      (fileFirst.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_33, _toDisplayString(_unref(translate)('VALIDATE_FILE_EXTENSION')), 1))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _hoisted_35,
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("h3", _hoisted_37, _toDisplayString(_unref(translate)('noteError')), 1),
                    _createElementVNode("h3", _hoisted_38, "※" + _toDisplayString(_unref(translate)('ST50noteError1')), 1),
                    _createElementVNode("h3", _hoisted_39, "※" + _toDisplayString(_unref(translate)('ST50noteError2')), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("label", _hoisted_41, _toDisplayString(_unref(translate)('attachment')) + "(2)", 1),
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("div", _hoisted_44, [
                      _createElementVNode("input", {
                        type: "file",
                        ref: (_value, _refs) => {
                          _refs['myFilesSecond'] = _value
                          myFilesSecond.value = _value
                        },
                        id: "filesSecond",
                        accept: "image/png, image/jpeg, image/jpg, application/pdf, text/plain",
                        onChange: handleChangeFileSecond,
                        onClick: handleFile,
                        class: "form-control d-none",
                        placeholder: "ファイル選択"
                      }, null, 544),
                      _createElementVNode("label", _hoisted_45, [
                        _createElementVNode("label", _hoisted_46, _toDisplayString(_unref(translate)('selectFile')), 1),
                        _createElementVNode("span", _hoisted_47, _toDisplayString(_unref(inquiryData)?.file2 ? fileNameSecond.value : '選択されていません'), 1),
                        _createElementVNode("label", {
                          onClick: handleDeleteFile2,
                          class: "input-group-text cursor-pointer bg-white fs-7"
                        }, _toDisplayString(_unref(translate)('ST50cancelFile')), 1)
                      ]),
                      (fileSecond.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_48, _toDisplayString(_unref(translate)('VALIDATE_FILE_EXTENSION')), 1))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_49, [
                  _hoisted_50,
                  _createElementVNode("div", _hoisted_51, [
                    _createElementVNode("h3", _hoisted_52, _toDisplayString(_unref(translate)('noteError')), 1),
                    _createElementVNode("h3", _hoisted_53, "※" + _toDisplayString(_unref(translate)('ST50noteError1')), 1),
                    _createElementVNode("h3", _hoisted_54, "※" + _toDisplayString(_unref(translate)('ST50noteError2')), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_55, [
                _createElementVNode("label", _hoisted_56, _toDisplayString(_unref(translate)('attachment')) + "(3)", 1),
                _createElementVNode("div", _hoisted_57, [
                  _createElementVNode("div", _hoisted_58, [
                    _createElementVNode("div", _hoisted_59, [
                      _createElementVNode("input", {
                        type: "file",
                        ref: (_value, _refs) => {
                          _refs['myFilesThird'] = _value
                          myFilesThird.value = _value
                        },
                        id: "filesThird",
                        accept: "image/png, image/jpeg, image/jpg, application/pdf, text/plain",
                        onChange: handleChangeFileThird,
                        onClick: handleFile,
                        class: "form-control d-none",
                        placeholder: "ファイル選択"
                      }, null, 544),
                      _createElementVNode("label", _hoisted_60, [
                        _createElementVNode("label", _hoisted_61, _toDisplayString(_unref(translate)('selectFile')), 1),
                        _createElementVNode("span", _hoisted_62, _toDisplayString(_unref(inquiryData)?.file3 ? fileNameThird.value : '選択されていません'), 1),
                        _createElementVNode("label", {
                          onClick: handleDeleteFile3,
                          class: "input-group-text cursor-pointer bg-white"
                        }, _toDisplayString(_unref(translate)('ST50cancelFile')), 1)
                      ]),
                      (fileThird.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_63, _toDisplayString(_unref(translate)('VALIDATE_FILE_EXTENSION')), 1))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_64, [
                  _hoisted_65,
                  _createElementVNode("div", _hoisted_66, [
                    _createElementVNode("h3", _hoisted_67, _toDisplayString(_unref(translate)('noteError')), 1),
                    _createElementVNode("h3", _hoisted_68, "※" + _toDisplayString(_unref(translate)('ST50noteError1')), 1),
                    _createElementVNode("h3", _hoisted_69, "※" + _toDisplayString(_unref(translate)('ST50noteError2')), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_70, [
                _createElementVNode("label", _hoisted_71, _toDisplayString(_unref(translate)('emailReply')), 1),
                _createElementVNode("div", _hoisted_72, [
                  _createVNode(Status)
                ]),
                _createElementVNode("div", _hoisted_73, [
                  _createElementVNode("div", _hoisted_74, [
                    _createElementVNode("div", _hoisted_75, [
                      _createElementVNode("div", _hoisted_76, [
                        _withDirectives(_createElementVNode("input", {
                          type: "email",
                          class: _normalizeClass(["form-control", ['form-control', _unref(v$).email.$error ? 'is-invalid' : '', _unref(isMobile) ? 'fs-75' : 'fs-7']]),
                          placeholder: "sample@yelloop.jp",
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(v$).email.$model) = $event))
                        }, null, 2), [
                          [
                            _vModelText,
                            _unref(v$).email.$model,
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        _createVNode(InputErrorMessage, {
                          title: _unref(translate)('emailReply'),
                          params: [_unref(MIN_LENGTH_EMAIL), _unref(MAX_LENGTH_EMAIL)],
                          validator: _unref(v$).email.$errors[0]?.$validator
                        }, null, 8, ["title", "params", "validator"])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_77, [
                _createElementVNode("div", _hoisted_78, [
                  _createVNode(Button, {
                    title: _unref(translate)('cancel'),
                    type: 'secondary',
                    onClick: handleBackFAQ,
                    "data-bs-dismiss": "modal",
                    class: _normalizeClass('button-confirm-modal')
                  }, null, 8, ["title"])
                ]),
                _createElementVNode("div", _hoisted_79, [
                  _createVNode(Button, {
                    title: _unref(translate)('confirm'),
                    type: 'secondary',
                    onClick: onSubmit,
                    dataBsTarget: '#inquiryConfirmModal',
                    dataBsToggle: ngKeyContent.value || _unref(v$).$invalid || fileFirst.value || fileSecond.value || fileThird.value ? '' : 'modal'
                  }, null, 8, ["title", "dataBsToggle"])
                ])
              ])
            ], 32)
          ])
        ])
      ])
    ], 512),
    _createVNode(InquiryConfirmModal, { handleServerError: handleServerError })
  ], 64))
}
}

})